import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProof } from '../components/SocialProof';
import { WhoIsThisFor } from '../components/WhoIsThisFor';
import { SystemSection } from '../components/SystemSection';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { ContactForm } from '../components/ContactForm';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-carbon text-white selection:bg-gold/30 selection:text-gold font-sans" lang="es" data-id="element-255">
      <main data-id="element-256">
        <HeroSection data-id="element-257" />
        <SocialProof data-id="element-258" />
        <WhoIsThisFor data-id="element-259" />
        <SystemSection data-id="element-260" />
        <Testimonials data-id="element-261" />
        <Guarantee data-id="element-262" />
        <FAQ data-id="element-263" />
        <ContactForm data-id="element-264" />
        <FinalCTA data-id="element-265" />
      </main>
      <Footer data-id="element-266" />
    </div>;
}